const calculateStep = (max, rangeInterval) => max % rangeInterval === 0 ? 0 : rangeInterval - max % rangeInterval;
export default calculateStep;
//# sourceMappingURL=calculate-step.js.map